import { Navigate, useParams, useRoutes } from "react-router-dom";

import DeploymentRoutes from "./deployment/routes";
import InvoiceRoutes from "./invoice/routes";
import PasswordPage from "./password";
import ProfilePage from "./profile";
import SyndicatedContentRoutes from "./syndicatedContent/routes";

export default () =>
  useRoutes([
    { path: "profile", element: <WithParameters component={ProfilePage}/> },
    { path: "password", element: <WithParameters component={PasswordPage}/> },
    { path: "syndicatedContent/*", element: <SyndicatedContentRoutes/> },
    { path: "deployment/*", element: <DeploymentRoutes/> },
    { path: "invoice/*", element: <InvoiceRoutes/> },
    { path: "*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
